import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from './baseQuery';
import {
  ILoginPayload,
  ILoginResponse,
  IVerifyTwoFactorPayload,
} from '../../shared/models/core/auth';
import { IUserInfo } from '../../shared/models/identity/user-info';

export const authApi = createApi({
  reducerPath: 'authApi',
  baseQuery,
  tagTypes: ['Session'],
  endpoints: (builder) => ({
    loginUser: builder.mutation<ILoginResponse, ILoginPayload>({
      query: (values) => ({
        url: '/api/auth/token',
        method: 'POST',
        body: values,
      }),
    }),
    refreshToken: builder.mutation<ILoginResponse, void>({
      query: () => ({
        url: '/api/auth/refresh',
        method: 'POST',
      }),
      invalidatesTags: ['Session'],
    }),
    logoutUser: builder.mutation<boolean, void>({
      query: () => ({
        url: '/api/auth/logout',
        method: 'POST',
      }),
      invalidatesTags: ['Session'],
    }),
    getSessionUser: builder.query<IUserInfo, void>({
      query: () => ({
        url: '/api/auth/session',
        method: 'GET',
      }),
      providesTags: ['Session'],
      keepUnusedDataFor: 300,
    }),
    verifyTwoFactor: builder.mutation<ILoginResponse, IVerifyTwoFactorPayload>({
      query: (values) => ({
        url: '/api/auth/verifyTwoFactor',
        method: 'POST',
        body: values,
      }),
    }),
  }),
});

export const {
  useLoginUserMutation,
  useRefreshTokenMutation,
  useGetSessionUserQuery,
  useLogoutUserMutation,
  useVerifyTwoFactorMutation,
} = authApi;
